export default __webpack_public_path__ + "static/media/hidupkan_event.dbe0fbdc.svg";